import { render, staticRenderFns } from "./DELETEFormFields.vue?vue&type=template&id=71b64515"
import script from "./DELETEFormFields.vue?vue&type=script&lang=js"
export * from "./DELETEFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports